import { getJobSyncListApi } from '~/modules/interview-onlineJob-module/apis/job.js'
import {
  getRemoteTaskAllListApi,
  getMyDemandApi,
  getMyDemandCountApi
} from "~/modules/interview-demand-module/apis/demand.js"

import { getOnboardingStatusApi, updateOnboardingStatusApi } from '~/modules/global-guide-module/api/global-guide.js'
import router from '~/router'

/**
 * 全局职位同步检查工具
 * 检查职位同步列表，如果返回长度为0则跳转到global-guide页面
 */
export class JobSyncChecker {
  constructor() {
    this.isChecking = false
    this.hasChecked = false
  }
  /**
   * 检测新手引导到状态welcome_tour_v1
   */
  async checkWelcomeTourStatus() {
    const res = await getOnboardingStatusApi()
    //检测data的key的长度
    if(Object.keys(res.data).length > 0) {
      return res.data.welcome_tour_v1
    }
    return "UNCOMPLETED"
  }
  /**
   * 检查职位同步列表
   * @param {Object} options - 检查选项
   * @param {string} options.recruitmentId - 招聘ID
   * @param {number} options.pageSize - 页面大小，默认10
   * @param {number} options.pageNum - 页码，默认1
   * @param {string} options.jobTitle - 职位标题
   * @param {string} options.createBy - 创建者
   * @param {boolean} options.forceCheck - 是否强制检查，默认false
   * @returns {Promise<boolean>} 返回是否有数据
   */
  async checkJobSyncList(options = {}) {
    const {
      recruitmentId = null,
      pageSize = 10,
      pageNum = 1,
      jobTitle = null,
      createBy = null,
      forceCheck = false
    } = options

    // 如果已经检查过且不是强制检查，则跳过
    if (this.hasChecked && !forceCheck) {
      return true
    }
    //获取当前登录用户的id
    const userId = JSON.parse(localStorage.getItem('userInfo'))?.userId || null;
    
    // 前置检查：无论什么情况都要检查职位状态
    try {
      const finalCreateBy = createBy || userId
      console.log('前置检查职位同步列表...')
      const response = await getMyDemandCountApi(
        finalCreateBy
      )
      // 独立检查职位存在状态并存储到localStorage
      const hasJobs = response.data.count> 0
      localStorage.setItem('hasJobs', hasJobs.toString())
      // 触发自定义事件通知组件更新
      window.dispatchEvent(new CustomEvent('hasJobsChanged', { detail: { hasJobs } }))
    } catch (error) {
      // 即使出现错误，也要存储职位状态为false
      localStorage.setItem('hasJobs', 'false')
      // 触发自定义事件通知组件更新
      window.dispatchEvent(new CustomEvent('hasJobsChanged', { detail: { hasJobs: false } }))
    }
    
    if(await this.checkWelcomeTourStatus() !== "UNCOMPLETED") {
      return true
    }
    // 如果正在检查中，则等待
    if (this.isChecking) {
      return new Promise((resolve) => {
        const checkInterval = setInterval(() => {
          if (!this.isChecking) {
            clearInterval(checkInterval)
            resolve(this.hasChecked)
          }
        }, 100)
      })
    }
    this.isChecking = true
    try {
      // 使用前置检查的结果，避免重复调用API
      const hasData = localStorage.getItem('hasJobs') === 'true'
      this.hasChecked = true
      const isInterviewer = localStorage.getItem('isInterviewer') === 'true' || false
      const isHR = localStorage.getItem('isHR') === 'true' || false
      const isAdmin = localStorage.getItem('isAdmin') === 'true' || false
      // 如果没有数据，返回false，由路由守卫处理跳转
      if (!hasData && (isHR || isAdmin)) {
        console.log('职位同步列表为空，返回false由路由守卫处理跳转')
        return false
      }

      return true

    } catch (error) {
      console.error('检查职位同步列表时发生错误:', error)
      this.hasChecked = true
      return false
    } finally {
      this.isChecking = false
    }
  }

  /**
   * 跳转到global-guide页面
   */
  redirectToGlobalGuide() {
    try {
      // 检查当前路由是否已经是global-guide，避免重复跳转
      if (router.currentRoute.value.path === '/global-guide') {
        console.log('当前已在global-guide页面，无需跳转')
        return
      }

      console.log('跳转到global-guide页面')
      
      // 使用replace而不是push，避免用户通过返回按钮回到空数据页面
      router.replace('/global-guide').then(() => {
        console.log('成功跳转到global-guide页面')
      }).catch((error) => {
        console.error('跳转到global-guide页面失败:', error)
        // 如果replace失败，尝试使用push
        router.push('/global-guide').catch((pushError) => {
          console.error('使用push跳转也失败:', pushError)
        })
      })
    } catch (error) {
      console.error('跳转到global-guide页面时发生错误:', error)
    }
  }

  /**
   * 重置检查状态
   */
  reset() {
    this.isChecking = false
    this.hasChecked = false
  }

  /**
   * 获取检查状态
   */
  getStatus() {
    return {
      isChecking: this.isChecking,
      hasChecked: this.hasChecked
    }
  }

  /**
   * 清除跳过状态，允许用户重新进行同步
   */
  clearSkipStatus() {
    localStorage.removeItem('jobSyncSkipped')
    console.log('已清除跳过状态，用户可以重新进行同步')
  }

  /**
   * 检查用户是否已跳过同步
   */
  isSkipped() {
    const skipData = localStorage.getItem('jobSyncSkipped')
    return skipData === 'true'
  }

  /**
   * 获取职位存在状态
   * @returns {boolean} 是否有职位
   */
  getHasJobsStatus() {
    const hasJobsData = localStorage.getItem('hasJobs')
    return hasJobsData === 'true'
  }
}

// 创建全局实例
export const jobSyncChecker = new JobSyncChecker()

// 默认导出
export default jobSyncChecker
